<template>
  <jet-authentication-card>
    <card-header>Forgot Password</card-header>

    <template #header>
      <jet-authentication-card-header />
    </template>
    <div class="text-sm text-gray-600 px-6 my-4">
      Forgot your password? No problem. Just let us know your email address and we will email you a
      password reset link that will allow you to choose a new one.
    </div>

    <div v-if="status" class="mt-4 px-6 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <jet-validation-errors class="px-6" />

    <form @submit.prevent="submit" class="p-6">
      <div>
        <jet-label for="email" value="Email" />
        <jet-input
          id="email"
          type="email"
          class="mt-1 block w-full"
          v-model="form.email"
          required
          autofocus
          autocomplete="on"
        />
      </div>

      <div class="flex items-center justify-end mt-4">
        <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
          Email Password Reset Link
        </jet-button>
      </div>
    </form>
  </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardHeader from '@/Jetstream/AuthenticationCardHeader.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import CardHeader from '@/Components/Cards/CardHeader.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';

export default {
  components: {
    JetAuthenticationCard,
    JetAuthenticationCardHeader,
    CardHeader,
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors,
  },

  props: {
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('clinician.password.email'));
    },
  },
};
</script>
